module.exports = __webpack_public_path__ + "img/map_Z2.1.C.03.79630fea.svg";